'use client'

import config from 'config'
import {
  ApolloClient,
  ApolloProvider,
  InMemoryCache,
  createHttpLink,
  from,
  ApolloLink
} from '@apollo/client'

import React, { ReactNode } from 'react'
import { getCsrf } from 'util/session'

const createCsrfLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => ({
    headers: {
      ...headers,
      'x-yellowdig-csrf-token': getCsrf()
    }
  }))
  return forward(operation)
})

const createDebugHeadersLink = new ApolloLink((operation, forward) => {
  operation.setContext(({ headers = {} }) => {
    const ua =
      typeof window !== 'undefined' &&
      window.navigator &&
      window.navigator.userAgent
    return {
      headers: {
        ...headers,
        'x-yellowdig-user-agent': ua,
        'x-yellowdig-url':
          typeof window !== 'undefined' && window.location.pathname
      }
    }
  })
  return forward(operation)
})

const httpLink = createHttpLink({
  uri: `${config.NEXT_PUBLIC_GALACTUS_URL}/graphql`,
  credentials: 'include'
})

const client = new ApolloClient({
  link: from([createCsrfLink, createDebugHeadersLink, httpLink]),
  cache: new InMemoryCache(),
  defaultOptions: {
    watchQuery: {
      fetchPolicy: 'network-only'
    },
    query: {
      fetchPolicy: 'network-only'
    }
  }
})

export const ApolloClientProvider = ({ children }: { children: ReactNode }) => {
  return <ApolloProvider client={client}>{children}</ApolloProvider>
}
